import {
  OPEN_REPLAY_INGEST,
  OPEN_REPLAY_KEY,
  DISABLE_OPEN_REPLAY_SECURE_MODE,
} from '@config/environment';
import { useCallback, useEffect, useMemo } from 'react';
import { Console } from '@utils';
import Tracker from '@openreplay/tracker';

export const openreplay: {
  current: Tracker | undefined;
} = { current: undefined };
const loading = {
  current: false,
};
export const getOpenreplay = (() => {
  return async () => {
    if (loading.current) {
      await new Promise((res) => {
        const interval = setInterval(() => {
          if (loading.current) return;
          clearInterval(interval);
          res(null);
        }, 100);
      });
      return openreplay.current;
    }
    if (!OPEN_REPLAY_KEY) return null;
    if (openreplay.current) return openreplay.current;

    loading.current = true;
    openreplay.current = new Tracker({
      projectKey: OPEN_REPLAY_KEY,
      obscureInputEmails: false,
      obscureInputNumbers: false,
      obscureTextEmails: false,
      obscureTextNumbers: false,
      ingestPoint: OPEN_REPLAY_INGEST ?? undefined,
      respectDoNotTrack: false,
      obscureInputDates: false,
      capturePerformance: true,
      defaultInputMode: 0,
      network: {
        capturePayload: true,
        captureInIframes: true,
        ignoreHeaders: [],
        failuresOnly: false,
        sessionTokenHeader: 'session-id',
      },
      canvas: {
        disableCanvas: false,
      },
      crossdomain: {
        enabled: true,
      },
      __DISABLE_SECURE_MODE: DISABLE_OPEN_REPLAY_SECURE_MODE, //add this to be able to send events in localhost
    });

    loading.current = false;

    return openreplay.current;
  };
})();

export function useOpenReplay() {
  useEffect(() => {
    void getOpenreplay().then((openReplay) => {
      openReplay?.start();
    });
  }, []);
}
export const openReplayTrack = async (event: string, payload?: unknown) => {
  Console.log('[OPEN_REPLAY][TRACK_EVENT]', {
    event,
    payload,
  });
  if (OPEN_REPLAY_KEY) {
    await getOpenreplay().then((openReplay) => {
      openReplay?.event(event, payload);
    });
  }
};

export function useOpenReplayTracking() {
  const trackEvent = useCallback(async (event: string, payload?: unknown) => {
    Console.log('[OPEN_REPLAY][TRACK_EVENT]', {
      event,
      payload,
    });
    if (OPEN_REPLAY_KEY) {
      await getOpenreplay().then((openReplay) => {
        openReplay?.event(event, payload);
      });
    }
  }, []);
  const trackIssue = useCallback(async (issue: string, payload?: unknown) => {
    Console.log('[OPEN_REPLAY][TRACK_ISSUE]', {
      issue,
      payload,
    });
    if (OPEN_REPLAY_KEY) {
      await getOpenreplay().then((openReplay) => {
        openReplay?.issue(issue, payload);
      });
    }
  }, []);
  const functions = useMemo(() => {
    return { trackEvent, trackIssue };
  }, [trackEvent, trackIssue]);
  return functions;
}
